import { useSelector } from "react-redux";
import { IReduxAppState } from "../../reducers";
import PageLayout from "../Layout";
import MenusSetupDialog from "../manageMenu/MenusSetupDialog";
import TaxSetUpDialog from "../taxes/TaxSetUpDialog";
import { VenueTypesModal } from "../VenueTypesModal";
import { DisableRouteComponent } from "./DisableRouteComponent";
import { OrdersContainer } from "./OrderContext";
import * as URLS from '../../const/URL.const';
import { Route, Switch } from "react-router-dom";
import { useStripeAccount } from "../../hooks/useStripeAccount";

interface IProps {
    children: React.ReactChild;
}
/**Wrap it around the main venue part of the app */
export function VenueWrapper({ children }: IProps) {
    const venueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const venue = useSelector((state: IReduxAppState) => state.venue[venueId]?.venueData);
    /**Hook for detecting stripe account data */
    useStripeAccount(venueId);

    return <OrdersContainer>
        <Route path={[URLS.ANALYTICS_DASHBOARD_URL, URLS.DISCOUNTS_URL, URLS.SUBSCRIPTION_URL,
        URLS.TAXES_URL, URLS.PRODUCTS_URL, URLS.PROFILE_URL, URLS.ORDERS_URL, URLS.SQUARE_SYNC, URLS.REVIEWS_URL, URLS.USER_MANAGEMENT]}
        >
            {
                venue?.payment_processor !== 'SQUARE' && <TaxSetUpDialog />
            }
            <MenusSetupDialog />
            <PageLayout sidebar={true} showHeader={true} title="" >
                <DisableRouteComponent>
                    <Switch>
                        {children}
                    </Switch>
                </DisableRouteComponent>
            </PageLayout>

            <VenueTypesModal venue={venue!} />
        </Route>
    </OrdersContainer>
}